<template>
    <div class="wrap">
        <iframe :src="src" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            src:process.env.VUE_APP_VERIFY,
        };
    },

    components: {},

    computed: {},

    created() {},

    mounted() {},

    methods: {},
};
</script>
<style lang='less' scoped>
.wrap{
    display: flex;
    flex: 1;
    background:#fff;
    box-sizing: border-box;
    iframe{
        flex:1
    }
}
</style>